import React from "react";

import {
  PRIMARIES,
  ACCESSORIES,
  OLYMPICS,
  STRONGMAN,
} from "../../../../utils/exercise-catalog";

const CatalogSelectors = ({
  onSelectorClick,
  filter,
  mobile,
  selectedExercises,
  search,
  onChangeFn,
}) => {
  return mobile ? (
    <div className="category-selectors">
      <header className="only-show-mobile">
        <input
          type="search"
          className="text-input search-exercise"
          name="search"
          placeholder="Search Exercise Here..."
          value={search}
          onChange={onChangeFn}
          autoComplete="off"
        />
      </header>
      <ul>
        {ACCESSORIES.map((value) => {
          return (
            <li
              key={`accessory-${value}`}
              className={`category-item${filter === value ? " active" : ""}`}
              onClick={() => onSelectorClick(value)}
            >
              {value}
            </li>
          );
        })}
        {PRIMARIES.map(({ value, label }) => {
          return (
            <li
              key={`primary-${value}`}
              className={`category-item${filter === value ? " active" : ""}`}
              onClick={() => onSelectorClick(value)}
            >
              {label}
            </li>
          );
        })}
        {OLYMPICS.map(({ value, label }) => {
          return (
            <li
              key={`primary-${value}`}
              className={`category-item${filter === value ? " active" : ""}`}
              onClick={() => onSelectorClick(value)}
            >
              {label}
            </li>
          );
        })}
        {STRONGMAN.map(({ value, label }) => {
          return (
            <li
              key={`primary-${value}`}
              className={`category-item${filter === value ? " active" : ""}`}
              onClick={() => onSelectorClick(value)}
            >
              {label}
            </li>
          );
        })}
      </ul>
    </div>
  ) : (
    <aside>
      <fieldset>
        <legend>Accessories</legend>
        <ul>
          {ACCESSORIES.map((value) => {
            let count = 0;
            selectedExercises.assistant.forEach((ex) => {
              if (ex.primaryMuscleGroup === value) count++;
              if (value === "Other" && !ex.primaryMuscleGroup) count++;
            });
            return (
              <li key={`accessory-${value}`}>
                <button
                  data-button-type={filter === value ? "primary" : "text-white"}
                  onClick={() => onSelectorClick(value)}
                >
                  {value} {count ? <span>{count}</span> : null}
                </button>
              </li>
            );
          })}
        </ul>
      </fieldset>

      <fieldset>
        <legend>Powerlifting</legend>
        <ul>
          {PRIMARIES.map(({ value, label }) => {
            return (
              <li
                key={`primary-${value}`}
                className={`category-item${filter === value ? " active" : ""}`}
              >
                <button
                  data-button-type={filter === value ? "primary" : "text-white"}
                  onClick={() => onSelectorClick(value)}
                >
                  {label}

                  {selectedExercises[value].length ? (
                    <span>{selectedExercises[value].length}</span>
                  ) : null}
                </button>
              </li>
            );
          })}
        </ul>
      </fieldset>

      <fieldset>
        <legend>Olympic Weightlifting</legend>
        <ul>
          {OLYMPICS.map(({ value, label }) => {
            return (
              <li
                key={`primary-${value}`}
                className={`category-item${filter === value ? " active" : ""}`}
              >
                <button
                  data-button-type={filter === value ? "primary" : "text-white"}
                  onClick={() => onSelectorClick(value)}
                >
                  {label}

                  {selectedExercises[value].length ? (
                    <span>{selectedExercises[value].length}</span>
                  ) : null}
                </button>
              </li>
            );
          })}
        </ul>
      </fieldset>

      <fieldset>
        <legend>Strongman & other</legend>
        <ul>
          {STRONGMAN.map(({ value, label }) => {
            return (
              <li
                key={`primary-${value}`}
                className={`category-item${filter === value ? " active" : ""}`}
              >
                <button
                  data-button-type={filter === value ? "primary" : "text-white"}
                  onClick={() => onSelectorClick(value)}
                >
                  {label}

                  {selectedExercises[value].length ? (
                    <span>{selectedExercises[value].length}</span>
                  ) : null}
                </button>
              </li>
            );
          })}
        </ul>
      </fieldset>
    </aside>
  );
};

export default CatalogSelectors;
